import * as types from './types';

export default {
  [types.SET_SIGNUP_TYPE](state, signupType) {
    state.signupType = signupType;
  },
  [types.SET_INFO](state, infos) {
    state.infos = infos;
  },
  [types.SET_INFO_LOADING](state, infoLoading) {
    state.infoLoading = infoLoading;
  },
};
